import React from 'react'
import { Platform, StyleSheet } from 'react-native'

import Cook from '../screens/cook'
import MealSelect from '../screens/meal_select'
import ShoppingList from '../screens/shopping_list'

import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import MaterialIcon from 'react-native-vector-icons/MaterialCommunityIcons'

const Tab = createBottomTabNavigator()

const activeColor = '#fff'
const inactiveColor = 'rgba(255, 255, 255, 0.6)'
const cardColor = '#193546' // This is defined in App.js too. We should break out a theme util file where these can be easily imported from

const styles = StyleSheet.create({
  bar: {
    height: Platform.OS == 'ios' ? 100 : 80, // This feels dicey as hell, but if it works on multiple screens then :shrug:
    paddingTop: 10,
    backgroundColor: cardColor,
    borderTopWidth: 0,

    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.6,
    shadowRadius: 20,
    elevation: 25,
  },
  item: {
    paddingBottom: 10,
  },
  label: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  activeIcon: {
    paddingHorizontal: 20,
    paddingVertical: 5,
    borderRadius: 100,
  },
})

const Icon = ({ focused, ...props }) => (
  <MaterialIcon style={focused ? styles.activeIcon : {}} {...props} />
)

const AppNavigator = () => (
  <Tab.Navigator
    screenOptions={{
      headerShown: false,
      tabBarLabelPosition: 'below-icon',
      tabBarActiveTintColor: activeColor,
      tabBarInactiveTintColor: inactiveColor,
      tabBarStyle: styles.bar,
      tabBarItemStyle: styles.item,
      tabBarLabelStyle: styles.label,
    }}
  >
    <Tab.Screen
      name="Meal Select"
      component={MealSelect}
      options={{
        tabBarIcon: (props) => <Icon name="noodles" {...props} />,
      }}
    />
    <Tab.Screen
      name="Shopping List"
      component={ShoppingList}
      options={{
        tabBarIcon: (props) => <Icon name="cart" {...props} />,
      }}
    />
    <Tab.Screen
      name="Cook"
      component={Cook}
      options={{
        tabBarIcon: (props) => <Icon name="history" {...props} />,
      }}
    />
  </Tab.Navigator>
)

export default AppNavigator
